export default {
  methods: {
    minervaStatusLabel(status) {
      if (!status) {
        return this.$t('form.publication.minervaSyncStatus');
      }
      const key = `publication.minervaSyncStates.${status}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    minervaStatusColor(status) {
      const colors = {
        'pending-check': 'grey lighten-1',
        'missing-data': 'deep-orange lighten-1',
        'sent-for-revision': 'indigo lighten-3',
        available: 'green',
        'wont-sync': 'blue-grey lighten-2',
      };
      return colors[status] || 'grey lighten-2';
    },
    minervaStatusBorderColor(status) {
      const colors = {
        'pending-check': '#bdbdbd',
        'missing-data': '#ff8a65',
        'sent-for-revision': '#9fa8da',
        available: '#4caf50',
        'wont-sync': '#90a4ae',
      };
      return colors[status] || '#e0e0e0';
    },
    minervaStatusTextColor(status) {
      const color = this.minervaStatusColor(status);
      if (!color) {
        return 'black';
      }
      if (color.includes('lighten')) {
        return 'black';
      }
      return 'white';
    },
    minervaMetadataSummary(item, options = {}) {
      if (!item || !item.minerva_sync_status) {
        return '';
      }
      const { includeMissingDataDetails = true } = options;
      const metadata = item.minerva_sync_metadata || {};
      switch (item.minerva_sync_status) {
        case 'missing-data': {
          if (!includeMissingDataDetails) {
            return '';
          }
          const missing = Array.isArray(metadata.missing_fields)
            ? metadata.missing_fields.filter(field => typeof field === 'string' && field.trim() !== '')
            : [];
          const labels = missing
            .map(field => this.minervaHumanReadableField(field))
            .filter(label => label);
          if (labels.length) {
            return this.$t('form.publication.minerva.summary.missingFields', {
              fields: labels.join(', ')
            });
          }
          return this.$t('form.publication.minerva.summary.missingFieldsEmpty');
        }
        case 'sent-for-revision': {
          const ticket = metadata.ticket || '—';
          const submitted = metadata.submitted_at || '';
          if (submitted) {
            return this.$t('form.publication.minerva.summary.sentForRevisionWithDate', {
              ticket,
              submitted
            });
          }
          return this.$t('form.publication.minerva.summary.sentForRevision', { ticket });
        }
        case 'wont-sync': {
          return (
            this.minervaResolveStatusCopy(
              'form.publication.minerva.summary',
              'wont-sync',
              item
            ) || ''
          );
        }
        default: {
          const raw = Object.keys(metadata).length ? JSON.stringify(metadata) : '';
          return raw;
        }
      }
    },
    minervaHumanReadableField(field) {
      const raw = typeof field === 'string' ? field.trim() : '';
      if (!raw) {
        return '';
      }
      const sanitized = raw.replace(/\./g, '_');
      const camelCase = sanitized.replace(/_([a-z])/g, (_, char) => char.toUpperCase());
      const lowerCamel = camelCase.charAt(0).toLowerCase() + camelCase.slice(1);
      const candidateKeys = [
        `form.publication.minerva.fieldLabels.${sanitized}`,
        `form.publication.${sanitized}`,
        `form.publication.${lowerCamel}`,
        `form.${sanitized}`,
        `form.${lowerCamel}`
      ];
      for (const key of candidateKeys) {
        if (this.$te(key)) {
          return this.$t(key);
        }
      }
      return sanitized
        .split('_')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    minervaStatusDescription(status, context = null) {
      return this.minervaResolveStatusCopy(
        'form.publication.minerva.statusDescriptions',
        status,
        context
      );
    },
    availableMinervaUrl(item) {
      if (
        !item ||
        item.minerva_sync_status !== 'available' ||
        !item.minerva_sync_metadata ||
        !item.minerva_sync_metadata.dspace_id
      ) {
        return '';
      }
      return `https://minerva.usc.gal/entities/publication/${item.minerva_sync_metadata.dspace_id}`;
    },
    formatMinervaLastCheckedAt(value) {
      if (!value) {
        return '';
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleString(this.$i18n ? this.$i18n.locale : undefined);
    },
    minervaResolveStatusCopy(baseKey, status, context = null) {
      if (!status) {
        return '';
      }
      const type = this.minervaDetectPublicationType(context);
      if (type) {
        const typedKey = `${baseKey}.${status}-${type}`;
        if (this.$te(typedKey)) {
          return this.$t(typedKey);
        }
      }
      const key = `${baseKey}.${status}`;
      return this.$te(key) ? this.$t(key) : '';
    },
    minervaDetectPublicationType(context) {
      if (!context || typeof context !== 'object') {
        return '';
      }
      if (context.publication_type) {
        return context.publication_type;
      }
      if (context.type) {
        return context.type;
      }
      if (context.thesis) {
        return 'thesis';
      }
      if (context.article) {
        return 'article';
      }
      if (context.bookandchapter) {
        return 'bookandchapter';
      }
      if (context.communication) {
        return 'communication';
      }
      return '';
    }
  }
};
